(function () {
    'use strict';

    function siteConfigurationRouteConfig($stateProvider) {

        $stateProvider
            .state('siteconfigurationeditor', {
                url: '/admin/siteconfigurations/edit/:siteId',
                template: '<site-configuration></site-configuration>',
                controller: 'configurationEditorController',
                controllerAs: 'configuration',
                resolve: {
                    createMode: function () {
                        return false;
                    },
                    configurationOptionsData: [
                        "$stateParams", "configurationOptionsDataService", function ($stateParams, configurationOptionsDataService) {
                            return configurationOptionsDataService.loadConfigurationOptions($stateParams.siteId).then(function (data) {
                                return data;
                            });
                        }
                    ],
                    configurationData: [
                        "$stateParams", "configurationDataService", function ($stateParams, configurationDataService) {
                            return configurationDataService.loadConfiguration($stateParams.siteId).then(function (data) {
                                return data;
                            });
                        }
                    ],
                    adminEntityConfigurationsData: [
                        "$stateParams", "adminEntityConfigurationDataService", function ($stateParams, adminEntityConfigurationDataService) {
                            return adminEntityConfigurationDataService.loadAll().then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('siteconfigurationcreate', {
                url: '/admin/siteconfigurations/create',
                template: '<site-configuration></site-configuration>',
                controller: 'configurationEditorController',
                controllerAs: 'configuration',
                resolve: {
                    createMode: function () {
                        return true;
                    },
                    configurationData: function() {
                        return {};
                    },
                    configurationOptionsData: [
                        "configurationOptionsDataService", function (configurationOptionsDataService) {
                            return configurationOptionsDataService.loadConfigurationOptions("newsite").then(function (data) {
                                return data;
                            });
                        }
                    ],
                    adminEntityConfigurationsData: [
                        "adminEntityConfigurationDataService", function (adminEntityConfigurationDataService) {
                            return adminEntityConfigurationDataService.loadAll().then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('siteconfigurations', {
                url: '/admin/siteconfigurations',
                templateUrl: 'siteConfiguration/templates/siteConfigurations.html',
                controller: 'siteConfigurationsController',
                controllerAs: 'siteConfigurations'
            })
            .state('adminentityconfigurationeditor', {
                url: '/admin/adminentityconfigurations/edit/:adminEntityType',
                template: '<admin-entity-configuration></admin-entity-configuration>',
                controller: 'adminEntityConfigurationEditorController',
                controllerAs: 'configuration',
                resolve: {
                    configurationOptionsData: [
                        "configurationOptionsDataService", function (configurationOptionsDataService) {
                            return configurationOptionsDataService.loadMasterConfigurationOptions().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    adminEntityConfigurationData: [
                        "$stateParams", "adminEntityConfigurationDataService", function ($stateParams, adminEntityConfigurationDataService) {
                            return adminEntityConfigurationDataService.load($stateParams.adminEntityType).then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('adminentityconfigurations', {
                url: '/admin/adminentityconfigurations',
                templateUrl: 'siteConfiguration/templates/adminEntityConfigurations.html',
                controller: 'adminEntityConfigurationsController',
                controllerAs: 'adminEntityConfigurations',
                resolve: {
                    adminEntityConfigurationsData: [
                        "adminEntityConfigurationDataService", function (adminEntityConfigurationDataService) {
                            return adminEntityConfigurationDataService.loadSummaries().then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            });
    }

    siteConfigurationRouteConfig.$inject = ['$stateProvider'];

    angular.module('ecap.siteConfiguration').config(siteConfigurationRouteConfig);
})();